import React from 'react';
import { Quote } from 'lucide-react';
import { Card, CardContent } from './ui/card';

const Testimonials = () => {
  const testimonials = [
    {
      text: "LaunchPilot turned our concept into a sleek, high-performing website in no time — truly a partner that brings ideas to life.",
      author: "Surendra Gajraj",
      role: "Founder, Vehiclean",
      company: "Vehiclean"
    },
    {
      text: "Working with LaunchPilot was a game-changer. They delivered our MVP in 3 weeks with exceptional quality and attention to detail.",
      author: "Sarah Chen",
      role: "CTO",
      company: "TechStart"
    },
    {
      text: "The team's expertise in AI integration helped us build a product that our users love. Highly recommended for any startup.",
      author: "Michael Rodriguez",
      role: "Product Lead",
      company: "InnovateLab"
    }
  ];

  return (
    <section className="py-24 px-6 relative bg-black">
      <div className="max-w-7xl mx-auto">
        <div className="text-center mb-16">
          <span className="text-white/60 font-semibold text-sm uppercase tracking-wide">Testimonials</span>
          <h2 className="text-4xl md:text-5xl font-extrabold mt-4 mb-4 text-white">
            Trusted by Founders
          </h2>
          <p className="text-gray-400 text-lg max-w-2xl mx-auto">See what our clients say about working with us</p>
        </div>

        <div className="grid md:grid-cols-3 gap-8">
          {testimonials.map((testimonial, index) => (
            <Card
              key={index}
              className="bg-white/5 border-white/10 hover:border-white/30 transition-all duration-300 hover:transform hover:-translate-y-2 backdrop-blur-sm"
            >
              <CardContent className="p-8">
                <Quote className="w-10 h-10 text-white/20 mb-4" />
                <p className="text-gray-300 leading-relaxed mb-6 italic">"{testimonial.text}"</p>
                <div className="border-t border-white/10 pt-4">
                  <div className="font-bold text-white">{testimonial.author}</div>
                  <div className="text-sm text-gray-400">{testimonial.role}</div>
                  <div className="text-xs text-gray-500 mt-1">{testimonial.company}</div>
                </div>
              </CardContent>
            </Card>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Testimonials;